import * as actionTypes from '../actions/index';

const initialState = {
	providers: null,
	providersPending: false,
	provider: null,
	mappings: null,
	mappingsPending: false,
	aliases: null,
	aliasesPending: false,
	mailboxes: null,
	mailboxesPending: false,
	mailboxMessages: null,
	mailboxMessagesPending: false,
	subscriptions: null,
	processed: null,
	processedPending: false,
	error: null
};

const leadsReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.LEADS_PROVIDERS_PENDING:
			return { ...state, providersPending: true, error: null };
		case actionTypes.LEADS_PROVIDERS_SUCCESS:
			return { ...state, providersPending: false, providers: action.providers };
		case actionTypes.LEADS_PROVIDERS_ERROR:
			return { ...state, providersPending: false, error: action.error };
		case actionTypes.LEADS_PROVIDER_SUCCESS:
			return { ...state, provider: action.provider };

		case actionTypes.LEADS_MAPPINGS_PENDING:
			return { ...state, mappingsPending: true, error: null };
		case actionTypes.LEADS_MAPPINGS_SUCCESS:
			return { ...state, mappingsPending: false, mappings: action.mappings };
		case actionTypes.LEADS_MAPPINGS_ERROR:
			return { ...state, mappingsPending: false, error: action.error };

		case actionTypes.LEADS_ALIASES_PENDING:
			return { ...state, aliasesPending: true, error: null };
		case actionTypes.LEADS_ALIASES_SUCCESS:
			return { ...state, aliasesPending: false, aliases: action.aliases };
		case actionTypes.LEADS_ALIASES_ERROR:
			return { ...state, aliasesPending: false, error: action.error };

		case actionTypes.LEADS_MAILBOXES_PENDING:
			return { ...state, mailboxesPending: true, error: null };
		case actionTypes.LEADS_MAILBOXES_SUCCESS:
			return { ...state, mailboxesPending: false, mailboxes: action.mailboxes };
		case actionTypes.LEADS_MAILBOXES_ERROR:
			return { ...state, mailboxesPending: false, error: action.error };

		case actionTypes.LEADS_MAILBOX_MESSAGES_PENDING:
			return { ...state, mailboxMessagesPending: true, error: null };
		case actionTypes.LEADS_MAILBOX_MESSAGES_SUCCESS:
			return { ...state, mailboxMessagesPending: false, mailboxMessages: action.mailboxMessages };
		case actionTypes.LEADS_MAILBOX_MESSAGES_ERROR:
			return { ...state, mailboxMessagesPending: false, error: action.error };

		case actionTypes.LEADS_SUBSCRIPTIONS_SUCCESS:
			return { ...state, subscriptions: action.subscriptions };

		case actionTypes.LEADS_PROCESSED_PENDING:
			return { ...state, processedPending: true, error: null };
		case actionTypes.LEADS_PROCESSED_SUCCESS:
			return { ...state, processedPending: false, processed: action.processed };
		case actionTypes.LEADS_PROCESSED_ERROR:
			return { ...state, processedPending: false, error: action.error };

		default:
			return state;
	}
};

export default leadsReducer;
